import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { SelectableAttribute } from "./selectable-attribute";
import { IBinding, ISelectableValue } from "../../../constants/product-customizations/customization";
import { TMetaSelectableSelection } from "constants/product-customizations/customization-selection.types";
import { DATATEST } from "../../../constants/integration";
import { themeOptions } from "styles/theme";

interface IProps {
    value: TMetaSelectableSelection;
    attributeId: string;
    label: string;
    index: number;
    readonly?: boolean;
    onChange: (arg: {
        valueKey: string;
        value: string;
        displayValue: string;
        valueId?: string;
        target?: IBinding;
    }) => void;
    target?: IBinding;
    attributeValue: ISelectableValue;
}

export const MetadataSelectableAttribute: React.FC<IProps> = ({
    value,
    label,
    onChange,
    readonly,
    index,
    attributeId,
    target,
    attributeValue,
}) => {
    const classes = useStyles();

    const handleAttributeChange = (value: TMetaSelectableSelection) => {
        onChange(value);
    };

    return (
        <div className={classes.childAttribute} data-test={`${DATATEST.CUSTOMIZATIONS.CHILD_ATTRIBUTE}_${index}`}>
            <div className={classes.attributeLabel}>{label}:</div>

            <SelectableAttribute
                isRequired={true}
                width="100%"
                selected={value}
                attributeValue={attributeValue}
                attributeId={attributeId}
                label={label}
                valueKey={`${index}`}
                readonly={readonly}
                onChange={handleAttributeChange}
                target={target}
            />
        </div>
    );
};

const useStyles = makeStyles({
    attributeLabel: {
        marginBottom: "5px",
        fontSize: 12,
        fontWeight: 700,
        color: themeOptions.palette.textColor,
    },
    childAttribute: {
        width: "45%",
        margin: "0 30px 21px 0",
    },
});
